/**
 * Program: reverse
 * Author: SDL
 * Description: character string inverted display
 */
export default val => val.split('').reverse().join('');



// WEBPACK FOOTER //
// ./src/filters/reverse.js